import HomeModal from "./homeModal";

export default HomeModal;
